<template>
  <!-- prettier-ignore -->
  <div v-show="showFab">
    <ovp-fab-button
      :is-toggle-active="showFabCard"
      :has-bottom-gap="isWww"
      @click="toggleFabCard(false)"
    />
    <ovp-fab-card
      :show-card="showFabCard"
      :entries="entries"
      @close="toggleFabCard(true)"
    />
  </div>
</template>

<script>
import OvpFabButton from '@/components/Fab/Button'
import OvpFabCard from '@/components/Fab/Card'
import { fabEntries } from '@/components/Fab/entries'
import ChatAccessMixin from '@/mixins/ChatAccess'

import { ContactHelper, DistributionHelper } from '@/helpers'

import {
  EVENT_DOTCOM_SURVEY_WEBSITE,
  EVENT_FAB_OPENED,
  CUSTOM_EVENT_CHAT_CONVERSATION_STARTED,
  CUSTOM_EVENT_CHAT_CLOSE,
} from '@/config/events'
import { mapState } from 'vuex'

export default {
  name: 'OvpFabContainer',

  components: {
    OvpFabButton,
    OvpFabCard,
  },

  mixins: [ChatAccessMixin],

  props: {
    isWww: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showFab: true,
      showFabCard: false,

      contactInfo: false,
    }
  },

  created() {
    window.addEventListener(CUSTOM_EVENT_CHAT_CONVERSATION_STARTED, this.hideFab)
    window.addEventListener(CUSTOM_EVENT_CHAT_CLOSE, this.displayFab)
  },

  beforeDestroy() {
    window.removeEventListener(CUSTOM_EVENT_CHAT_CONVERSATION_STARTED, this.hideFab)
    window.removeEventListener(CUSTOM_EVENT_CHAT_CLOSE, this.displayFab)
  },

  mounted() {},

  watch: {
    'basket.distributionPartners': {
      immediate: true,
      handler: function (value) {
        if (value) {
          const distributionPartnerNumber = DistributionHelper.getDistributionPartnerByBasket(this.basket)

          ContactHelper.getRawInfo(
            distributionPartnerNumber,
            this.basket.persons?.[0]?.partnerNumber,
            this.basket.channel
          ).then(data => (this.contactInfo = data))
        }
      },
    },
  },

  computed: {
    ...mapState('basket', ['collective', 'existingCustomer']),

    entries() {
      // FLEX-1373: Hide Alva in FAB on SCPC collective entry
      const hideAide = this.$route?.meta?.aide || this.collective?.channel === 'SCPC'
      const entries = fabEntries(this.isWww, hideAide, this.existingCustomer)

      if (this.contactInfo) {
        if (!this.contactInfo.alva) {
          delete entries.alva
        }

        entries.contact.title = this.contactInfo.name

        if (!this.contactInfo.chatOpeningTime) {
          const delIndex = entries.contact.links.findIndex(l => l.id === 'chat')
          if (delIndex !== -1) entries.contact.links.splice(delIndex)
        }

        if (this.contactInfo.phoneNumber && entries.contact.links.length > 0) {
          const ref = entries.contact.links.find(l => l.id === 'phone')

          ref.name = this.contactInfo.phoneNumber
          ref.url = `tel:${this.contactInfo.phoneNumber}`
          ref.isRaw = true
        }
      }

      return entries
    },
  },

  methods: {
    displayFab() {
      this.showFab = true
    },

    hideFab() {
      this.showFab = false
    },

    toggleFabCard(interacted) {
      this.showFabCard = !this.showFabCard

      if (this.showFabCard) {
        this.$EventBus.$emit(EVENT_FAB_OPENED)
      }

      // FLEX-1064 survey trigger in dvp and dotcom
      if (!this.showFabCard && !interacted) {
        this.$EventBus.$emit(EVENT_DOTCOM_SURVEY_WEBSITE)
      }
    },
  },
}
</script>

<style name="mobile" scoped></style>
